import {
  ref,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default function useActiveTrip(props, ctx) {
  const activeTripColumns = [
    {
      label: 'Trip number',
      key: 'external_id',
      formatter: val => (val || '_'),
    },
    {
      label: 'Created looking',
      key: 'CREATED',
      formatter: val => (val?.created_at && val?.action_by ? `${formatDate(val?.created_at)} - by: ${val?.action_by} ` : '_'),
    },
    {
      label: 'Looking for driver ',
      key: 'LOOKING_FOR_DRIVER',
      formatter: val => (val?.created_at && val?.action_by ? `${formatDate(val?.created_at)} - by: ${val?.action_by} ` : '_'),
    },
    {
      label: 'Accepted at',
      key: 'ACCEPTED',
      formatter: val => (val?.created_at && val?.action_by ? `${formatDate(val?.created_at)} - by: ${val?.action_by} ` : '_'),
    },
    {
      label: 'Arrived at',
      key: 'ARRIVED',
      formatter: val => (val?.created_at && val?.action_by ? `${formatDate(val?.created_at)} - by: ${val?.action_by} ` : '_'),
    },
    {
      label: 'Completed',
      key: 'COMPLETED',
      formatter: val => (val?.created_at && val?.action_by ? `${formatDate(val?.created_at)} - by: ${val?.action_by} ` : '_'),
    },
    {
      label: 'Canceled',
      key: 'CANCELED',
      formatter: val => (val?.created_at && val?.action_by ? `${formatDate(val?.created_at)} - by: ${val?.action_by} ` : '_'),
    },
  ]

  const tripStatesList = ref([])
  const loading = ref(false)
  const fetchActiveTrip = async () => {
    try {
      loading.value = true
      const res = await ctx.root.$store.dispatch('driverUsersTrips/fetchActiveTrips', { id: ctx.root.$route.query.externalId, userType: props.type })
      const activeTripDetails = res
      if (Object.keys(activeTripDetails).length) {
        const obj = {
          external_id: activeTripDetails?.external_id,
        }
        activeTripDetails?.states?.forEach(element => {
          obj[element.state] = {
            created_at: element.created_at,
            action_by: element.metadata.action_by,
          }
        })
        tripStatesList.value.push(obj)
      }
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
  fetchActiveTrip()
  return {
    activeTripColumns,
    tripStatesList,
    loading,
  }
}
